import React, {Component} from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import LockIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import Ability from "../../../config/Ability";

const styles = theme => ({
    layout: {
        width: "auto",
        display: "block", // Fix IE11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto",
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: "100%", // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
});

class SignIn extends Component {

    constructor(props) {
        super();
        this.loginData = {};
        // console.debug("signin",props);
        this._login = this._login.bind(this);
        this._onChange = this._onChange.bind(this);
    }

    componentWillMount() {
        if (this.props.user.isAuthenticated) {
            if(Ability.can("view","/transaction")){
                this.props.history.push("/transaction");
            }else{
                if(Ability.can("view","/technicalService")){
                    this.props.history.push("/technicalService");
                }else{
                    this.props.history.push("/insurance");
                }
            } 
        }
    }

    componentDidUpdate() {
        if (this.props.user.isAuthenticated) {
            if(Ability.can("view","/transaction")){
                this.props.history.push("/transaction");
            }else{
                if(Ability.can("view","/technicalService")){
                    this.props.history.push("/technicalService");
                }else{
                    this.props.history.push("/insurance");
                }
            } 
        }
    }

    state = {
        loading: false,
        success: false,
    };

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    _onChange(e) {
        this.loginData[e.target.name] = e.target.value;
    }

    _login(e) {
        e.preventDefault();
        if (!this.props.user.loading) {
            this.props.userLogin(this.loginData.email,this.loginData.password);
        }
    }
    

    render() {
        //const {success} = this.state;
        const {classes, user} = this.props;
        // const buttonClassname = classNames({
        //     [classes.buttonSuccess]: success,
        // });
        

        return (
            <React.Fragment>
                <CssBaseline/>
                <main className={classes.layout}>
                    <Paper className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockIcon/>
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>
                        <form className={classes.form} onSubmit={this._login}>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="email">Email Address</InputLabel>
                                <Input id="email" name="email" autoComplete="email" autoFocus  onChange={this._onChange}/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <Input
                                    name="password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    onChange={this._onChange}
                                />
                            </FormControl>
                            {/*<FormControlLabel*/}
                            {/*control={<Checkbox value="remember" color="primary" />}*/}
                            {/*label="Remember me"*/}
                            {/*/>*/}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={this.handleButtonClick}
                                disabled={user.loading ? true : false}
                            >
                                Sign in
                            </Button>
                        </form>
                    </Paper>
                </main>
            </React.Fragment>
        );
    }
}

SignIn.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignIn);
